export const USER_IS_A_MEMBER_COOKIE = 'userIsAMember';
export const HIGH_CONTRAST_COOKIE = 'highContrast';
export const LONG_TIME_COOKIE_EXPIRATION = '10Y';
export const HIGH_CONTRAST_MODE_BODY_CLASS = 'high-contrast';
export const MOBILE_PHONE_REGEXP = '^(70|20|30|31)\\s\\d{3}\\s\\d{4}$';
export const NAME_REGEXP = "^[\\p{L}\\s\\.\\-\\']*$";
export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD';
export const FRONTEND_DATE_FORMAT = 'YYYY.MM.DD.';
export const ZIP_REGEXP = '^\\d{4}$';
